export enum ModifyCsrType {
  DueDate = 0,
  AccountInfo
}

export const ModifyCsrTypes: Record<ModifyCsrType, string> = {
  [ModifyCsrType.DueDate]: "Update due date",
  [ModifyCsrType.AccountInfo]: "Update account information"
};
